import { configureStore } from "@reduxjs/toolkit";
import cartReducer, { loadCartFromStorage } from "./cartSlice.js";
import userReducer , {loadUserFromStorage} from "./userSlice.js"
import categoriesReducer, {loadCategories, loadMainCategories} from "./categoriesSlice.js"
import appConfigReducer, {loadAppConfig} from "./appConfigSlice.js"

// configures the redux store
// serves as root reducer: combines individual reducers (reducer slices)

const store = configureStore( {
  reducer: {
    cart: cartReducer,
    user: userReducer, 
    categories: categoriesReducer,
    appConfig: appConfigReducer, 
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

// on app load, do:
//    load user from local/session storage, save to store 
//    load cart from local storage, save to store
//    load categories from server, save to store 
//    load app config data from server, save to store 
store.dispatch(loadUserFromStorage());
store.dispatch(loadMainCategories());
store.dispatch(loadAppConfig());
store.dispatch(loadCartFromStorage());
store.dispatch(loadCategories()); 
export default store; 